import React, { useState, useEffect, useCallback } from "react";
import { hot } from "react-hot-loader";
import css from "./App.css";
import StyledButton from "common/StyledButton";
import { orderBy } from "lodash";
import Modal from "react-modal";
import AddCategoryModal from "./AddCategoryModal";
import Icon from "SF/MaterialIcon";
import useStarfishAPI from "hooks/useStarfishAPI";
import ErrorMessage from "common/ErrorMessage";

// Endpoint URL
const URL = `../api/reserved-time-categories`;

const App = () => {
  Modal.setAppElement(document.getElementById("main-center"));
  const [isOpen, setIsOpen] = useState(false);
  const [id, setId] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [enabled, setEnabled] = useState(false);

  const [response, callAPI] = useStarfishAPI({ isNewAPI: true });

  const closeModal = () => {
    setId(null);
    setTitle("");
    setDescription("");
    setEnabled(false);
    setIsOpen(false);
  };

  const onEdit = category => {
    setId(category.id);
    setTitle(category.title);
    setDescription(category.description);
    setEnabled(category.enabled);
    setIsOpen(true);
  };

  const getError = () => {
    const errorMessage = response.error;
    return errorMessage ? <ErrorMessage message={errorMessage} /> : null;
  };

  const fetchCategories = useCallback(() => {
    callAPI(URL, {
      method: "GET",
      headers: {
        Pragma: "no-cache",
        "Cache-Control": "no-cache",
        Expires: "-1"
      }
    });
  }, []);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  return (
    <div className={css["container"]}>
      <h3 className="sf-admin-title">Reserve Time Categories</h3>
      {getError()}
      <StyledButton
        inverted
        className={css["button"]}
        onClick={() => setIsOpen(true)}
        data-role="addReserveTimeCategory"
      >
        <Icon icon="add_circle" />
        Add Category
      </StyledButton>
      {response.pending && <div>Loading categories...</div>}
      {response.success && response.data.length === 0 ? (
        <div>No Reserve Time Categories Found.</div>
      ) : (
        <table className={css["table"]}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Status</th>
              <th>Description</th>
              <th>Tools</th>
            </tr>
          </thead>
          <tbody>
            {orderBy(response.data, [
              category => category.title.toLowerCase()
            ]).map(category => (
              <tr key={category.id}>
                <td>{category.title}</td>
                <td>{category.enabled ? "Enabled" : "Disabled"}</td>
                <td>{category.description}</td>
                <td className={css["icon-container"]}>
                  <button
                    aria-label="Edit Category"
                    onClick={() => onEdit(category)}
                  >
                    <Icon icon="edit" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <AddCategoryModal
        isOpen={isOpen}
        closeModal={closeModal}
        id={id}
        setId={setId}
        title={title}
        setTitle={setTitle}
        description={description}
        setDescription={setDescription}
        enabled={enabled}
        setEnabled={setEnabled}
        fetchCategories={fetchCategories}
      />
    </div>
  );
};

export default hot(module)(App);
